"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/VideoRooms/Room/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _LinkBar = require('./LinkBar'); var _LinkBar2 = _interopRequireDefault(_LinkBar);

var _AddAdmins = require('web/screens/VideoRooms/Modals/AddAdmins'); var _AddAdmins2 = _interopRequireDefault(_AddAdmins);



var _AdminPreview = require('web/screens/VideoRooms/AdminPreview');














const MeetingRoom = ({
  onRoomShare,
  onRoomLinkCopy,
  roomKey,
  roomLink,
  roomAdminsLists,
  onRemoveAdmin,
}) => {
  const [isAddAdminsModalOpen, setIsAddAdminsModalOpen] = _react.useState.call(void 0, false)

  const openAddAdminsModal = _react.useCallback.call(void 0, () => setIsAddAdminsModalOpen(true), [])
  const closeAddAdminsModal = _react.useCallback.call(void 0, () => setIsAddAdminsModalOpen(false), [])

  const { UserAdmins = [], TeamAdminKeys = [] } = roomAdminsLists

  return (
    _react2.default.createElement('div', { className: "meeting-room", __self: this, __source: {fileName: _jsxFileName, lineNumber: 39}}
      , _react2.default.createElement('div', { className: "meeting--management--section meeting--management--link-section" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 40}}
        , _react2.default.createElement('h4', { className: "meeting--management--section--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 41}}, "Meeting Link" )
        , _react2.default.createElement(_LinkBar2.default, {
          link: roomLink,
          className: "meeting--management--link-bar",
          onShare: onRoomShare,
          onCopy: onRoomLinkCopy, __self: this, __source: {fileName: _jsxFileName, lineNumber: 42}}
        )
      )
      , _react2.default.createElement('div', { className: "meeting--management--section", __self: this, __source: {fileName: _jsxFileName, lineNumber: 49}}
        , _react2.default.createElement('h4', { className: "meeting--management--section--title meeting--management--section--title--admins" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 50}}, "Hosts ("
           ,  UserAdmins.length + TeamAdminKeys.length , ")"
        )
        , _react2.default.createElement('div', { className: "meeting--management--admins-list", __self: this, __source: {fileName: _jsxFileName, lineNumber: 53}}
          , 
            UserAdmins.map(({ UserKey, OrgKey }) => (
              _react2.default.createElement(_AdminPreview.AdminUserPreview, {
                key: UserKey,
                userKey: UserKey,
                orgKey: OrgKey,
                onRemove: () => onRemoveAdmin(UserKey), __self: this, __source: {fileName: _jsxFileName, lineNumber: 56}}
              )
            ))
          
          , 
            TeamAdminKeys.map(teamKey => (
              _react2.default.createElement(_AdminPreview.AdminTeamPreview, {
                key: teamKey,
                teamKey: teamKey,
                onRemove: () => onRemoveAdmin(teamKey), __self: this, __source: {fileName: _jsxFileName, lineNumber: 66}}
              )
            ))
          
          , _react2.default.createElement('span', {
            onClick: openAddAdminsModal,
            className: "meeting--management--admins-add", __self: this, __source: {fileName: _jsxFileName, lineNumber: 73}}
, "Add hosts"

          )
        )
        , _react2.default.createElement('span', { className: "meeting--management--note", __self: this, __source: {fileName: _jsxFileName, lineNumber: 80}}, "Hosts approve requests to join a meeting, and can remove anyone from an ongoing meeting."

        )
      )
      , _react2.default.createElement(_AddAdmins2.default, {
        isOpen: isAddAdminsModalOpen,
        onClose: closeAddAdminsModal,
        roomKey: roomKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 84}}
      )
    )
  )
}

exports. default = MeetingRoom
